import { format } from 'date-fns'

/**
 * Formatting utility functions for consistent data display across components
 */

// Standard date format constants matching admin portal standards
// See: C:\azagent\CassieCloud\Vue.Frontends\shared\utils\date-formatting.js
const DATE_FORMAT = 'yyyy/MM/dd'
const DATE_TIME_FORMAT_NO_SECONDS = 'yyyy/MM/dd HH:mm'

/**
 * Format a date string for display using admin portal standard formats
 * @param dateString - ISO date string to format
 * @param formatType - Display format ('full' includes time as yyyy/MM/dd HH:mm, 'short' is date only as yyyy/MM/dd)
 * @returns Formatted date string in admin portal standard format
 */
export function formatDate(dateString: string, formatType: 'full' | 'short' = 'full'): string {
  try {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return 'Invalid date'

    const dateFormat = formatType === 'short' ? DATE_FORMAT : DATE_TIME_FORMAT_NO_SECONDS
    return format(date, dateFormat)
  } catch (e) {
    console.error('Date formatting error:', e)
    return 'Invalid date'
  }
}

/**
 * Format duration in seconds to human-readable string
 * @param seconds - Duration in seconds (can be null/undefined)
 * @returns Human-readable duration string (e.g., "2h 30m" or "-" if null)
 */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null) return '-'

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  const parts: string[] = []
  if (hours > 0) parts.push(`${hours}h`)
  if (minutes > 0) parts.push(`${minutes}m`)
  if (secs > 0 || parts.length === 0) parts.push(`${secs}s`)

  return parts.join(' ')
}
